import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

export function EmptyState({
  Icon,
  title,
  body,
  action,
}: {
  Icon: LucideIcon
  title: string
  body?: string
  action?: ReactNode
}) {
  return (
    <div className="bg-white rounded-lg border border-dashed border-neutral-300 p-10 text-center">
      <div className="mx-auto inline-flex p-3 rounded-full bg-neutral-100 text-neutral-400">
        <Icon size={28} aria-hidden="true" />
      </div>
      <h3 className="mt-4 text-base font-bold text-primary">{title}</h3>
      {body && <p className="mt-1 text-sm text-neutral-600 max-w-sm mx-auto">{body}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
